import React from 'react';

import Button from 'components/button/Button';
import { REQUEST_FORM_URL } from 'shared/constants';

interface GuestModalProps {
  withBg?: boolean;
}

const GuestModal = ({ withBg }: GuestModalProps) => {
  const handleClick = () => {
    window.dataLayer?.push({
      event: 'click_request_rooms',
      type: withBg ? 'listing_page_searchbar' : 'main',
    });

    window.open(REQUEST_FORM_URL, '_blank');
  };

  return (
    <div className="flex w-full flex-col gap-y-3 px-5 py-[30px]">
      <h5 className="whitespace-pre break-keep text-b4">{`Sorry, we are currently\noffering rooms for 1 person. `}</h5>
      <p className="w-full text-c4 text-gray-40">{`If you are planning to stay with someone,\nplease fill out the form below. Thank you:)`}</p>
      <Button
        shape="SQUARE"
        font="text-c2"
        className="py-5"
        text={`Request a list of rooms\nthat meet your criteria`}
        onClick={handleClick}
      />
    </div>
  );
};

export default GuestModal;
